<template>
  <div v-if="actions.length > 0" class="mb-5 w-lg-95 w-xl-100 mx-auto border-bottom">
    <!-- Title -->
    <div class="row mb-3">
      <div class="col-6">
        <h2 data-v-418d363c="" class="mb-0 text-primary text-center">Vos idées</h2>
      </div>
      <div class="col-6 text-right">
        <a class="btn btn-primary btn-pill transition-3d-hover" href="/module/dlnkactions/actions">Voir toutes les idées&nbsp;<i class="fas fa-angle-right fa-sm ml-1"></i></a>
      </div>
    </div>
    <!-- End Title -->
    <div class="row">
      <div v-for="action in actions" :key="action.id" class="col-sm-6 col-md-4">
        <!-- Team -->
        <div class="card h-100 transition-3d-hover">
          <div class="card-body pb-0">
            <div class="mb-3">
              <img class="avatar avatar-sm avatar-circle" :src="action.author.photo" alt="Photo de l'auteur">
            </div>

            <a :href="`/module/dlnkactions/action?id=${action.id}`">
              <h4 class="text-lh-sm">{{action.title}}</h4>
            </a>
            <p class="mb-0">
              <span class="d-block font-italic mb-2">proposée par {{ action.author.name }}, le {{ action.created_date_fr_short }}</span>
            </p>
            <p class="font-size-1">{{action.description}}</p>
          </div>

          <div class="card-footer border-0 pt-0">
            <div class="d-flex justify-content-between align-items-center">
              <div class="col-9 text-right">
                <a href="/connexion" v-if="customer_id == 0" class="btn btn-sm btn-primary w-100">
                  <i class="fa fa-thumbs-up fa-lg"></i>&nbsp;J'aime
                </a>
                <button v-else-if="action.liked == 1 " class="btn btn-sm btn-danger w-100" type="button" @click="dislike(action.id)">
                  <i class="fa fa-thumbs-down fa-lg" aria-hidden="true"></i>
                  &nbsp;Je n'aime plus
                </button>
                <button v-else class="btn btn-sm btn-primary w-100" type="button" @click="like(action.id)">
                  <i class="fa fa-thumbs-up fa-lg" aria-hidden="true"></i>
                  &nbsp;J'aime
                </button>
              </div>
              <div class="col-3">
                <div class="row">
                  <div class="col-6 text-right pr-0">
                    <span v-text="action.total_votes"></span>
                  </div>
                  <div class="col-6 text-left">
                    <i class="fa fa-thumbs-up" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End Team -->
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    'group_id': Number,
  },
  data: function () {
    return {
      actions: [],
      customer_id: 0,
    }
  },
  mounted() {
    this.get_data();
  },

  methods: {

    get_data: function() {
      this.get_actions()
    },

    get_actions: async function () {
      const _this = this;
      let [secure_key, customer_id, api_url] = await get_token_2()
      _this.customer_id = customer_id
      api_url += `ideas.json`

      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      if (typeof _this.group_id !== 'undefined') {
        api_url += '&group_id=' + _this.group_id
      }

      axios.get( api_url)
          .then(function (response) {
            _this.actions = response.data.ideas
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
                // always executed
              }
          );
    },

    like: async function (id) {
      const _this = this;
      let [secure_key, customer_id, api_url] = await get_token_2()
      api_url += `ideas/${id}/like.json`

      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      axios({
        method: 'post',
        url: api_url,
        headers: { "cache-control": "no-cache" },
      })
          .then(function (response) {
            _this.get_data()
          })
          .catch(function (error) {
            const field = Object.keys(error.response.data)[0]
            const error_message = error.response.data[field][0]
            _this.message = error_message;
            _this.message_type = "alert-danger";
          });
    },

    dislike: async function (id) {
      const _this = this;
      let [secure_key, customer_id, api_url] = await get_token_2()
      api_url += `ideas/${id}/dislike.json`

      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      axios({
        method: 'delete',
        url: api_url,
        headers: { "cache-control": "no-cache" },
      })
          .then(function (response) {
            _this.get_data()
          })
          .catch(function (error) {
            const field = Object.keys(error.response.data)[0]
            const error_message = error.response.data[field][0]
            _this.message = error_message;
            _this.message_type = "alert-danger";
          });
    },

  }
}
</script>